import React from "react";
import about from "../../Image/about.png";
import Footer from "../Footer";
import PageHeader from "../PageHader/PageHeader";
import { ArrowSmRightIcon } from "@heroicons/react/outline";
import { useNavigate } from "react-router-dom";
const About = (props) => {
  const d = new Date();
  let year = d.getFullYear();
  let navigate = useNavigate();
 const pageRedirect=()=>{
  setTimeout(() => {
    navigate("/Contact");
  }, 3000);
  if (!navigate("/about")) {
    return navigate("/Intermetent");
  }
 }
 const startDate = new Date(2021, 3, 8);// april 8th 2021
  const endDate = new Date(); // April 18th 2022
  const monthDiff =endDate.getMonth() -startDate.getMonth() +12 * (endDate.getFullYear() - startDate.getFullYear());
  console.log(monthDiff);
  return (
    <center>
      <PageHeader back="Back" text="About Me"/>

      <div >
        <div className="flex flex-col  justify-center  lg:flex-row ">
          <div className="lg:w-[45%] xl:w-[35%] lg:mt-40">
            <p className="dark:text-white text-[16px] py-4 px-4  md:text-[18pxl] lg:text-[20px] ">
            I am a qualified and professional Frontend developer with <span className="text-[#17A6DB] dark:text-[#30dada] font-bold"> {monthDiff}</span>  month of experience in website development. I’m a located in India.. I have a serious
              passion for UI effects, animations and creating intuitive, dynamic
              user experiences.
            </p>
            <p className="dark:text-white text-[16px] py-4 px-4  md:text-[18pxl] lg:text-[20px] ">
              Well-organised person, problem solver, independent employee with
              high attention to detail. 
            </p>
            <p className="dark:text-white text-[16px] py-4 px-4  md:text-[18pxl] lg:text-[20px] ">
              Interested in the entire frontend spectrum and working on
              ambitious projects with positive people.
            </p>
            <p className="text-[#17A6DB] dark:text-[#30dada] flex  text-[16px] py-4 px-4  md:text-[18pxl] lg:text-[20px] cursor-pointer" onClick={pageRedirect}>
            Let’s make something special.<ArrowSmRightIcon className="w-5 ml-2" /> </p>
          </div>
          <div className="lg:w-[50%]">
            <img src={about} alt="" className="" />
          </div>
        </div>
      </div>
      <div className=" mt-[70px] md:mt-[40px] md:block lg:mt-[200px]">
        <p className="text-[#17A6DB] dark:text-[#30dada] flex justify-center pb-4 md:pb-0">
        Developed  and Design @{year} by Deepesh Kumar. 
        </p>
        <Footer />
      </div>
    </center>
  );
};

export default About;
